"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackorderWidget = void 0;
const core_1 = require("@material-ui/core");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const store_3 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const dashboard_1 = require("shared/dashboard");
const uppercase_string_1 = require("shared/util/uppercase-string");
const styles = core_1.createStyles({
    root: {},
    widgetContainer: {
        padding: "1rem"
    },
    siteSelectContainer: {
        display: "flex",
        justifyContent: "flex-end"
    },
    siteSelect: {
        "height": "60px",
        "width": "300px",
        "& * span": {
            lineHeight: "normal",
            whiteSpace: "normal"
        }
    },
    row: {
        "&:nth-child(odd)": {
            background: "#f9f9f9 !important"
        }
    },
    backorderTable: {
        "& * .material-list__header-item:nth-child(2)": {
            flex: "0 0 70px !important"
        },
        "& * .material-list-item-text:nth-child(2)": {
            flex: "0 0 70px !important"
        },
        "& * .material-list__header-item:nth-child(4)": {
            flex: "0 0 100px !important"
        },
        "& * .material-list-item-text:nth-child(4)": {
            flex: "0 0 100px !important"
        }
    }
});
const decorate = core_1.withStyles(styles);
const columns = [
    {
        label: "inventory name",
        id: "inventory name"
    },
    {
        label: "type",
        id: "type"
    },
    {
        label: "ref",
        id: "ref"
    },
    {
        label: "expected Date",
        id: "expected date"
    }
];
let BackorderWidgetUnstyled = class BackorderWidgetUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.siteId = null;
        this.loadBackorders = async () => {
            const query = {
                siteId: this.siteId
            };
            await store_1.dashboardStore.loadBackorderData(query);
        };
        this.renderTableRow = (row) => {
            const purchaseOrder = row.purchaseOrder;
            let transitionRoute = "";
            const distributorId = row.distributor ? row.distributor.id : "";
            switch (row.type) {
                case dashboard_1.BackorderType.Distributor:
                    transitionRoute = `/order/distributors/${distributorId}`;
                    break;
                // Should redirect to purchaseOrder review
                case dashboard_1.BackorderType.SiteBackorder:
                case dashboard_1.BackorderType.SiteBackorderSubstitute:
                    transitionRoute = `/order/review/${purchaseOrder.id}`;
                    break;
                case dashboard_1.BackorderType.Formulary:
                    transitionRoute = `/formulary/0/${row.inventory.id}`;
                    break;
                default:
                    console.error("Invalid backorder type");
                    break;
            }
            const inventoryName = row.inventoryName;
            return (React.createElement(list_item_1.MaterialListItem, { className: this.props.classes.row, to: transitionRoute, onClick: () => console.info("clicked") },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.type }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.ref }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.expectedDate })));
        };
        this.handleOnSelect = async (value) => {
            console.info("value is", value);
            if (value === "All") {
                this.siteId = 0;
            }
            else {
                this.siteId = Number(value);
            }
            await this.loadBackorders();
        };
    }
    get availableSiteOptions() {
        // const user = usersStore.user.value || null;
        // const showAllSites = usersStore.permissions.ReadPharmacies;
        // const options = sitesListStore.sites.value
        //   .filter(
        //     site =>
        //       showAllSites ||
        //       site.id === user.site.id ||
        //       (user.sites as number[]).includes(site.id)
        //   )
        //   .map((site, i: number) => ({
        //     id: i + 1,
        //     label: site.displayName || site.name,
        //     value: String(site.id)
        //   }));
        // if (true) {
        //   options.unshift({
        //     id: 0,
        //     label: "All sites",
        //     value: "0"
        //   });
        // }
        const user = store_3.usersStore.user.value || null;
        const showAllSites = store_3.usersStore.permissions.ReadPharmacies;
        const options = store_2.sitesListStore.sites.value.filter(site => showAllSites || site.id === (user === null || user === void 0 ? void 0 : user.site.id) || (user === null || user === void 0 ? void 0 : user.sites).includes(site.id))
            .map((site, i) => ({
            id: i + 1,
            label: site.displayName || site.name,
            value: String(site.id)
        }));
        if (true) {
            options.unshift({
                id: 0,
                label: "All Pharmacies",
                value: "0"
            });
        }
        return options;
    }
    get backorderMetas() {
        return store_1.dashboardStore.backorderData;
    }
    async componentDidMount() {
        await store_2.sitesListStore.loadSitesNoRelation();
        this.siteId = store_3.usersStore.user.value.siteId || null;
        await this.loadBackorders();
    }
    render() {
        const { classes } = this.props;
        return (React.createElement("div", { className: "widget" },
            React.createElement("div", { className: classes.siteSelectContainer },
                React.createElement(select_1.MaterialSelect, { className: classes.siteSelect, options: this.availableSiteOptions || [], label: "site", onSelect: this.handleOnSelect, value: String(this.siteId) })),
            React.createElement("br", null),
            React.createElement("div", { className: classes.backorderTable },
                React.createElement(list_1.MaterialList, { columns: columns, rows: this.backorderMetas, renderRow: this.renderTableRow }))));
    }
};
__decorate([
    mobx_1.observable
], BackorderWidgetUnstyled.prototype, "siteId", void 0);
__decorate([
    mobx_1.computed
], BackorderWidgetUnstyled.prototype, "availableSiteOptions", null);
__decorate([
    mobx_1.computed
], BackorderWidgetUnstyled.prototype, "backorderMetas", null);
BackorderWidgetUnstyled = __decorate([
    mobx_react_1.observer
], BackorderWidgetUnstyled);
exports.BackorderWidget = decorate(BackorderWidgetUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/backorder-widget/backorder-widget.tsx
// module id = 3341
// module chunks = 0